import Column from "@components/column";
import React from "react";
import Wallet from "./wallet";
import Refer from "./refer";
import Reward from "./reward";

const Customer = () => {
  return (
    <Column>
      <Wallet />
      <Refer />
      <Reward />
    </Column>
  );
};

export default Customer;
